import { LoadingSpinner } from '../util/spinner/loading-spinner'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useLegalPrivacyPolicy } from 'src/hook/use-legal'

export const PrivacyPolicy = (): React.ReactElement => {
  const { data: privacyPolicy, isLoading } = useLegalPrivacyPolicy()

  return (
    <LoadingSpinner isLoading={isLoading || !privacyPolicy}>
      {privacyPolicy && (
        <ReactMarkdown
          className={'markdown-table'}
          remarkPlugins={[remarkGfm]}
          transformLinkUri={(src: string): string => {
            if (src[0] === '#') return window.location.pathname + src
            return src
          }}
        >
          {privacyPolicy}
        </ReactMarkdown>
      )}
    </LoadingSpinner>
  )
}
